import {
  Button,
  CircularProgress,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import { TELEHEALTH_CANCEL_LABEL } from "../telehealth-v2-constant";

export interface InitializingScreenProps {
  message: string;
  /** Rendered as a Cancel button when provided, so a stalled init is escapable. */
  onCancel?: () => void;
  sx?: SxProps<Theme>;
}

export default function InitializingScreen({
  message,
  onCancel,
  sx,
}: Readonly<InitializingScreenProps>) {
  return (
    <Stack
      role="status"
      aria-live="polite"
      sx={[
        {
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        },
        {
          bgcolor: "background.paper",
          color: "text.primary",
          p: 4,
          textAlign: "center",
          height: "100%",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CircularProgress />
      <Typography
        sx={{
          color: "text.secondary",
        }}
      >
        {message}
      </Typography>
      {onCancel && (
        <Button variant="outlined" onClick={onCancel}>
          {TELEHEALTH_CANCEL_LABEL}
        </Button>
      )}
    </Stack>
  );
}
